import * as domUtility from './domUtility';
import * as mathUtility from './mathUtility';

export const utils = {
    dom: domUtility,
    math: mathUtility
};

export const initializeUtilities = () => {
    (globalThis as unknown as any)['utils'] = utils;
}
